import { css } from '@emotion/react';

export const base = css({
  display: 'grid',
});

export const fullHeight = css({
  minHeight: '100%',
});
